import { render, staticRenderFns } from "./LatestPublicationListModern.vue?vue&type=template&id=3aadf536"
import script from "./LatestPublicationListModern.vue?vue&type=script&lang=js"
export * from "./LatestPublicationListModern.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports